import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-58de4bbe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "menu"
};
const _hoisted_2 = { class: "version" };
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useMessage } from '@/const/messages';
import ChatPlus from '@/materials/atoms/ChatPlus.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isShowMenu: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { format, HELP } = useMessage();
        const version = String(process.env.VUE_APP_VERSION);
        const showChat = () => {
            window.ChatplusScript.openChat();
            window.ChatplusScript.showChat();
            // const chatplus = document.getElementById('chatplusview');
            // if (chatplus) {
            //   chatplus.hidden = false;
            //   chatplus.removeAttribute('style');
            // }
        };
        const showEmail = () => {
            window.open('https://www.bigboss-financial.com/questions_inquiries');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (props.isShowMenu)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: "list",
                            onClick: showEmail
                        }, [
                            _createVNode(MaterialIcon, {
                                class: "icon middle",
                                name: "mail"
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(HELP).MAIL)), 1)
                        ]),
                        _createElementVNode("div", {
                            class: "list",
                            onClick: showChat
                        }, [
                            _createVNode(MaterialIcon, {
                                class: "icon middle",
                                name: "forum"
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(HELP).CHAT)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(format)(_unref(HELP).VERSION)) + " : " + _toDisplayString(_unref(version)), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(ChatPlus)
            ], 64));
        };
    }
});
